/**
 * AppShell — persistent layout wrapping every authenticated route.
 *
 * Header on top (brand · nav · user menu, with a hamburger at < 768px),
 * then the routed page content below. Auth is enforced by the parent
 * route via <RequireAuth>; this component assumes a user is in the store.
 */

import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth';
import { AppHeader } from './components/AppHeader';
import styles from './AppShell.module.css';

export function AppShell() {
  const tenantName = useAuthStore((s) => s.tenantUser?.tenantName);

  useEffect(() => {
    document.title = tenantName ? `Linqage — ${tenantName}` : 'Linqage';
  }, [tenantName]);

  return (
    <div className={styles.root}>
      <AppHeader />
      <main className={styles.main}>
        <div className={styles.content}>
          <Outlet />
        </div>
      </main>
    </div>
  );
}
